/* 🤖 this file was generated by svg-to-ts */
export const DfIconCheckmark12: {
  name: 'checkmark-12';
  data: string;
} = {
  name: 'checkmark-12',
  data: `<svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path d="M5.714 8.691a1.005 1.005 0 0 1-.034.034.987.987 0 0 1-1.458-.1L2.29 6.688a.985.985 0 0 1 0-1.394.987.987 0 0 1 1.395 0l1.318 1.32 3.315-3.327a.987.987 0 0 1 1.394 0 .984.984 0 0 1 0 1.393L5.715 8.69z" fill-rule="evenodd"/></svg>`
};
